/**
 * KAN-625: метка аккаунта (label), инлайн-редактор в ячейке аккаунта.
 * 1..64 символа, пустую сохранить нельзя.
 */
import { InlineTextEditor } from '@/components/ui/inline-text-editor';
import type { TelegramAccount } from '@/types/telegramAccount';
import { useAccountPatch } from './useAccountPatch';

const MAX_LENGTH = 64;
const SAVE_ERROR = 'Не удалось сохранить метку';

export function AccountLabelEditor({
  account,
  fallback,
}: {
  account: TelegramAccount;
  /** Что показать, если метка пуста. */
  fallback: string;
}): JSX.Element {
  const key = `${account.operator_id}-${account.account_id}`;
  const current = account.label ?? '';
  const save = useAccountPatch(account, SAVE_ERROR);

  return (
    <InlineTextEditor
      value={current}
      display={current || fallback}
      onSave={(label) => save.mutate({ label })}
      testId={`account-label-${key}`}
      inputTestId={`account-label-input-${key}`}
      errorTestId={`account-label-error-${key}`}
      ariaLabel="Метка аккаунта"
      title="Изменить метку"
      maxLength={MAX_LENGTH}
      required
      showPencil
      pencilText="метка"
      viewClassName="font-medium"
      inputClassName="h-7 w-full rounded border px-2 text-sm font-medium"
    />
  );
}
